import {useEffect, useState} from 'react';
import {markCookieNoticeShown, wasCookieNoticeShown} from '../../utils/consent';

const HIDE_DELAY_MS = 5000;

// Informational cookie notice: no buttons, auto-hides after a few seconds
// and is not shown again on later visits. Analytics runs regardless.
export default function CookieConsent() {
    const [visible, setVisible] = useState(() => !wasCookieNoticeShown());

    useEffect(() => {
        if (!visible) return;
        markCookieNoticeShown();
        const timer = setTimeout(() => setVisible(false), HIDE_DELAY_MS);
        return () => clearTimeout(timer);
    }, [visible]);

    if (!visible) return null;

    return (
        <div
            role="status"
            aria-live="polite"
            className="fixed inset-x-0 bottom-0 z-[70] p-3 sm:p-4"
        >
            <div
                className="mx-auto max-w-[1110px] rounded-2xl bg-white shadow-2xl border border-brand-dark/10 p-4 sm:p-5">
                <p className="text-sm text-brand-dark/80 leading-relaxed">
                    Продолжая пользоваться сайтом, ты согласен использовать куки, так работает
                    интернет и велит{' '}
                    <a href="/privacy-policy.html"
                       className="text-brand-red underline hover:opacity-80">
                        закон РФ
                    </a>.
                </p>
            </div>
        </div>
    );
}
